import styled from "styled-components";
import { COLORS, responsive } from "../../../../styles/constants.style";

export const UsersSearchResultWrapper = styled.div`
  margin: 19px 0px 39px;
  ${responsive.MOBILE`
    margin-top: 16px;
    margin-bottom: 16px;
  `}

  .result-header {
    display: flex;
    align-items: center;
    background-color: ${COLORS.primary_light_blue2};
    padding: 6px 16px;

    .header-text {
      line-height: 20px;
      color: ${COLORS.cirrus_black10};
    }

    .selected-count {
      color: ${COLORS.cirrus_white};
      background-color: ${COLORS.cirrus_black7};
      padding: 2px 9px 4px 9px;
      border-radius: 8px;
      margin-left: 8px;
      height: 28px;
    }
  }

  .export-button {
    ${responsive.MOBILE`
      background-color: ${COLORS.cirrus_white};
      margin: 8px 0px;
      display: flex;
      justify-content: right;
      padding-right: 16px;
    `}
  }

  .MuiGrid2-container {
    ${responsive.MOBILE`
      background-color: ${COLORS.cirrus_white};
    `}
  }

  .MuiTableCell-root .mui-text-field {
    height: 48px;
  }
  
  .min-width-cell {
    min-width: 250px;
  }
`;
